import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

import StaffOjtModal from './Elements/StaffOjtModal';

class StaffOjtsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      staff_ojts: {},
     };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.showOjtModal = this.showOjtModal.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ojts/finalizados';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/ojts');
        if (responseJson.status === 'success') {
          self.setState({
            staff_ojts: responseJson.data.main,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
     });
    });
  }
  showOjtModal (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ojt/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_staff_ojt:responseJson.data.main});
          self.setState({staff_ojt_aircraft_models:responseJson.data.aircraft_models});
          self.setState({staff_ojt_aircraft_model_subtypes:responseJson.data.aircraft_model_subtypes});
          self.setState({staff_ojt_manufacturers:responseJson.data.staff_ojt_manufacturers});
          self.setState({staff_ojt_items:responseJson.data.staff_ojt_items});
          self.setState({examiner:responseJson.data.examiner});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }
  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">OJTs realizados</h3>
      <hr/>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Colaborador</th>
            <th className="text-center">Tarefa</th>
            <th className="text-center">Data final</th>
            <th className="text-center">Função treinada</th>
            <th className="text-center">Ordem de serviço</th>
            <th className="text-center">Base</th>
            <th className="text-center">Satisfatório</th>
            <th className="text-center">Status</th>
            <th className="text-center col-md-1">Ações</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.staff_ojts).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.staff_ojts[k].staff.name}</td>
                <td className="text-center">{self.state.staff_ojts[k].ojt.name}</td>
                <td className="text-center">{self.state.staff_ojts[k].date_finish_str}</td>
                <td className="text-center">{self.state.staff_ojts[k].trained_role}</td>
                <td className="text-center">{self.state.staff_ojts[k].service_order}</td>
                <td className="text-center">{self.state.staff_ojts[k].base.name}</td>
                <td className="text-center">{self.state.staff_ojts[k].result}</td>
                <td className="text-center">
                  {(self.state.staff_ojts[k].status_str == 'Aprovado') ? <span className="label label-success">{self.state.staff_ojts[k].status_str}</span> : '' }
                  {(self.state.staff_ojts[k].status_str == 'Reprovado') ? <span className="label label-danger">{self.state.staff_ojts[k].status_str}</span> : '' }
                  {(self.state.staff_ojts[k].status_str == 'Pendente') ? <span className="label label-warning">{self.state.staff_ojts[k].status_str}</span> : '' }
                </td>
                <td className="text-center">
                  <button onClick={self.showOjtModal.bind(self, self.state.staff_ojts[k])}  className="btn btn-xs btn-info"><i className="fa fa-fw fa-eye"></i></button>                
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <StaffOjtModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} staff_ojt_aircraft_models={self.state.staff_ojt_aircraft_models} staff_ojt_aircraft_model_subtypes={self.state.staff_ojt_aircraft_model_subtypes} staff_ojt_manufacturers={self.state.staff_ojt_manufacturers} staff_ojt_items={self.state.staff_ojt_items} data_staff_ojt={self.state.data_staff_ojt}  examiner={self.state.examiner} />
    </div>
  </div>
</div>
    );
  }
}

export default StaffOjtsIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffOjts/StaffOjtsIndex.js